import styled from 'styled-components';

export const RadiosContainer = styled.div`
  margin: 30px 0;
`;
